var _dec, _class, _PlayPauseButton;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyle, jsx } from '@instructure/emotion';
import { IconPlaySolid, IconPauseSolid } from '@instructure/ui-icons';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import * as VideoStates from '../videoStates';
import { translate } from '../../../../constants/translated/translations';
import generateStyle from './styles';
import generateComponentTheme from './theme';

/**
---
private: true
---
**/
let PlayPauseButton = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_PlayPauseButton = class PlayPauseButton extends Component {
  constructor(...args) {
    super(...args);
    this.handleKeyDown = e => {
      // prevent FF from emitting a keyboard event
      if (e.key === ' ') {
        e.stopPropagation();
      }
    };
  }
  componentDidMount() {
    this.props.makeStyles();
  }
  componentDidUpdate() {
    this.props.makeStyles();
  }
  config(variant) {
    const VARIANTS = {
      [VideoStates.PAUSED]: {
        label: translate('PLAYBACK_PLAY'),
        Icon: IconPlaySolid
      },
      [VideoStates.ENDED]: {
        label: translate('PLAYBACK_PLAY'),
        Icon: IconPlaySolid
      },
      [VideoStates.PLAYING]: {
        label: translate('PLAYBACK_PAUSE'),
        Icon: IconPauseSolid
      }
    };
    return VARIANTS[variant];
  }
  render() {
    const _this$props = this.props,
      variant = _this$props.variant,
      onClick = _this$props.onClick,
      buttonRef = _this$props.buttonRef,
      videoId = _this$props.videoId,
      styles = _this$props.styles;
    const _this$config = this.config(variant),
      label = _this$config.label,
      Icon = _this$config.Icon;
    return jsx("button", {
      css: styles.button,
      onClick: onClick,
      onKeyDown: this.handleKeyDown,
      "aria-controls": videoId,
      ref: buttonRef
    }, jsx(ScreenReaderContent, null, label), jsx(Icon, {
      size: "x-small"
    }));
  }
}, _PlayPauseButton.propTypes = {
  // eslint-disable-next-line react/require-default-props
  makeStyles: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  styles: PropTypes.object,
  /**
   * Id of the video element. Used to ensure
   * correct aria properties are applied.
   */
  videoId: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(Object.values(VideoStates)),
  onClick: PropTypes.func,
  buttonRef: PropTypes.func
}, _PlayPauseButton.defaultProps = {
  variant: VideoStates.PAUSED,
  onClick: e => {},
  buttonRef: ref => {}
}, _PlayPauseButton)) || _class);
export default PlayPauseButton;